module.exports = __webpack_public_path__ + "static/media/compass.cbbeb4de.svg";